/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Address } from './Address';
import {
    AddressFromJSON,
    AddressFromJSONTyped,
    AddressToJSON,
    AddressToJSONTyped,
} from './Address';
import type { DeliveryHandoffInstructions } from './DeliveryHandoffInstructions';
import {
    DeliveryHandoffInstructionsFromJSON,
    DeliveryHandoffInstructionsFromJSONTyped,
    DeliveryHandoffInstructionsToJSON,
    DeliveryHandoffInstructionsToJSONTyped,
} from './DeliveryHandoffInstructions';
import type { MenuOrderItem } from './MenuOrderItem';
import {
    MenuOrderItemFromJSON,
    MenuOrderItemFromJSONTyped,
    MenuOrderItemToJSON,
    MenuOrderItemToJSONTyped,
} from './MenuOrderItem';
import type { HandoffOptions } from './HandoffOptions';
import {
    HandoffOptionsFromJSON,
    HandoffOptionsFromJSONTyped,
    HandoffOptionsToJSON,
    HandoffOptionsToJSONTyped,
} from './HandoffOptions';
import type { PhoneNumberBody } from './PhoneNumberBody';
import {
    PhoneNumberBodyFromJSON,
    PhoneNumberBodyFromJSONTyped,
    PhoneNumberBodyToJSON,
    PhoneNumberBodyToJSONTyped,
} from './PhoneNumberBody';

/**
 * 
 * @export
 * @interface CreateMenuOrderBody
 */
export interface CreateMenuOrderBody {
    /**
     * 
     * @type {string}
     * @memberof CreateMenuOrderBody
     */
    business?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMenuOrderBody
     */
    deliveryQuoteId?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateMenuOrderBody
     */
    tipMerchant?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateMenuOrderBody
     */
    tipDelivery?: number;
    /**
     * 
     * @type {Address}
     * @memberof CreateMenuOrderBody
     */
    address?: Address;
    /**
     * 
     * @type {string}
     * @memberof CreateMenuOrderBody
     */
    merchantNotes?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMenuOrderBody
     */
    deliveryNotes?: string;
    /**
     * 
     * @type {DeliveryHandoffInstructions}
     * @memberof CreateMenuOrderBody
     */
    deliveryHandoffInstructions?: DeliveryHandoffInstructions;
    /**
     * 
     * @type {number}
     * @memberof CreateMenuOrderBody
     */
    scheduledTime?: number;
    /**
     * 
     * @type {HandoffOptions}
     * @memberof CreateMenuOrderBody
     */
    handoff?: HandoffOptions;
    /**
     * 
     * @type {Array<MenuOrderItem>}
     * @memberof CreateMenuOrderBody
     */
    orderItems?: Array<MenuOrderItem>;
    /**
     * 
     * @type {string}
     * @memberof CreateMenuOrderBody
     */
    email?: string;
    /**
     * 
     * @type {PhoneNumberBody}
     * @memberof CreateMenuOrderBody
     */
    phoneNumber?: PhoneNumberBody;
    /**
     * 
     * @type {string}
     * @memberof CreateMenuOrderBody
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMenuOrderBody
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMenuOrderBody
     */
    paymentMethodId?: string;
    /**
     * Total Fuel used across all payment methods (off-chain + on-chain).
     * @type {number}
     * @memberof CreateMenuOrderBody
     */
    fuelTotal?: number;
    /**
     * Off-chain Fuel portion.
     * @type {number}
     * @memberof CreateMenuOrderBody
     */
    fuel?: number;
    /**
     * On-chain FuelX portion.
     * @type {number}
     * @memberof CreateMenuOrderBody
     */
    onChainFuelX?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateMenuOrderBody
     */
    fuelFiatAtOrderTime?: number;
    /**
     * USD amount of LootShop credit the user elects to apply (LootShop orders only). Server clamps to balance and order total.
     * @type {number}
     * @memberof CreateMenuOrderBody
     */
    lootShopCreditApplied?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CreateMenuOrderBody
     */
    isMagicWallet?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateMenuOrderBody
     */
    isCoinbase?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateMenuOrderBody
     */
    discountSelected?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateMenuOrderBody
     */
    discountCodes?: Array<string>;
    /**
     * 
     * @type {Address}
     * @memberof CreateMenuOrderBody
     */
    shippingAddress?: Address;
}



/**
 * Check if a given object implements the CreateMenuOrderBody interface.
 */
export function instanceOfCreateMenuOrderBody(value: object): value is CreateMenuOrderBody {
    return true;
}

export function CreateMenuOrderBodyFromJSON(json: any): CreateMenuOrderBody {
    return CreateMenuOrderBodyFromJSONTyped(json, false);
}

export function CreateMenuOrderBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateMenuOrderBody {
    if (json == null) {
        return json;
    }
    return {
        
        'business': json['business'] == null ? undefined : json['business'],
        'deliveryQuoteId': json['deliveryQuoteId'] == null ? undefined : json['deliveryQuoteId'],
        'tipMerchant': json['tipMerchant'] == null ? undefined : json['tipMerchant'],
        'tipDelivery': json['tipDelivery'] == null ? undefined : json['tipDelivery'],
        'address': json['address'] == null ? undefined : AddressFromJSON(json['address']),
        'merchantNotes': json['merchantNotes'] == null ? undefined : json['merchantNotes'],
        'deliveryNotes': json['deliveryNotes'] == null ? undefined : json['deliveryNotes'],
        'deliveryHandoffInstructions': json['deliveryHandoffInstructions'] == null ? undefined : DeliveryHandoffInstructionsFromJSON(json['deliveryHandoffInstructions']),
        'scheduledTime': json['scheduledTime'] == null ? undefined : json['scheduledTime'],
        'handoff': json['handoff'] == null ? undefined : HandoffOptionsFromJSON(json['handoff']),
        'orderItems': json['orderItems'] == null ? undefined : ((json['orderItems'] as Array<any>).map(MenuOrderItemFromJSON)),
        'email': json['email'] == null ? undefined : json['email'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : PhoneNumberBodyFromJSON(json['phoneNumber']),
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'paymentMethodId': json['paymentMethodId'] == null ? undefined : json['paymentMethodId'],
        'fuelTotal': json['fuelTotal'] == null ? undefined : json['fuelTotal'],
        'fuel': json['fuel'] == null ? undefined : json['fuel'],
        'onChainFuelX': json['onChainFuelX'] == null ? undefined : json['onChainFuelX'],
        'fuelFiatAtOrderTime': json['fuelFiatAtOrderTime'] == null ? undefined : json['fuelFiatAtOrderTime'],
        'lootShopCreditApplied': json['lootShopCreditApplied'] == null ? undefined : json['lootShopCreditApplied'],
        'isMagicWallet': json['isMagicWallet'] == null ? undefined : json['isMagicWallet'],
        'isCoinbase': json['isCoinbase'] == null ? undefined : json['isCoinbase'],
        'discountSelected': json['discountSelected'] == null ? undefined : json['discountSelected'],
        'discountCodes': json['discountCodes'] == null ? undefined : json['discountCodes'],
        'shippingAddress': json['shippingAddress'] == null ? undefined : AddressFromJSON(json['shippingAddress']),
    };
}

export function CreateMenuOrderBodyToJSON(json: any): CreateMenuOrderBody {
    return CreateMenuOrderBodyToJSONTyped(json, false);
}

export function CreateMenuOrderBodyToJSONTyped(value?: CreateMenuOrderBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'business': value['business'],
        'deliveryQuoteId': value['deliveryQuoteId'],
        'tipMerchant': value['tipMerchant'],
        'tipDelivery': value['tipDelivery'],
        'address': AddressToJSON(value['address']),
        'merchantNotes': value['merchantNotes'],
        'deliveryNotes': value['deliveryNotes'],
        'deliveryHandoffInstructions': DeliveryHandoffInstructionsToJSON(value['deliveryHandoffInstructions']),
        'scheduledTime': value['scheduledTime'],
        'handoff': HandoffOptionsToJSON(value['handoff']),
        'orderItems': value['orderItems'] == null ? undefined : ((value['orderItems'] as Array<any>).map(MenuOrderItemToJSON)),
        'email': value['email'],
        'phoneNumber': PhoneNumberBodyToJSON(value['phoneNumber']),
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'paymentMethodId': value['paymentMethodId'],
        'fuelTotal': value['fuelTotal'],
        'fuel': value['fuel'],
        'onChainFuelX': value['onChainFuelX'],
        'fuelFiatAtOrderTime': value['fuelFiatAtOrderTime'],
        'lootShopCreditApplied': value['lootShopCreditApplied'],
        'isMagicWallet': value['isMagicWallet'],
        'isCoinbase': value['isCoinbase'],
        'discountSelected': value['discountSelected'],
        'discountCodes': value['discountCodes'],
        'shippingAddress': AddressToJSON(value['shippingAddress']),
    };
}

